import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../layouts/DefaultLayout";
import { withRouter } from "react-router-dom";
import { Button, Card, Col, Input, Row, Table } from "antd";
import { debounce } from "lodash";

/**
 * Shows insurance rate files.
 */
@inject("context")
@withRouter
@observer
class ActiveRates extends Component {
	componentDidMount() {
		this.reloadRateFiles();
	}

	render() {
		const service = this.props.context.rateFilesService;

		const columns = [
			{
				title: "Uploaded At",
				dataIndex: "uploadedAt",
				sorter: true,
				defaultSortOrder: "descend",
				render: (date) => {
					return new Date(date).toLocaleDateString();
				},
			},
			{
				title: "Validated At",
				dataIndex: "validatedAt",
				sorter: true,
				defaultSortOrder: "descend",
				render: (date) => {
					return new Date(date).toLocaleDateString();
				},
			},
			{
				title: "Active From",
				dataIndex: "activeFrom",
				sorter: true,
				defaultSortOrder: "descend",
				render: (date) => {
					return new Date(date).toLocaleDateString();
				},
			},
			{
				title: "File Name",
				dataIndex: "name",
				sorter: true,
			},
			{
				title: "Insurer",
				dataIndex: ["insurer", "name"],
			},
			{
				title: "Actions",
				render: (field, record) => {
					return (
						<>
							<Button
								type="primary"
								onClick={() => this.handleValidateButtonClick(record)}
							>
								Validate
							</Button>
							<Button
								type="default"
								onClick={() => this.handleDownloadButtonClick(record)}
							>
								Download
							</Button>
						</>
					);
				},
			},
		];

		return (
			<DefaultLayout
				layoutContentProps={{
					style: {
						maxWidth: "100%",
						paddingLeft: 40,
						paddingRight: 40,
					},
				}}
			>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Active Rates</h1>}>
							<Row>
								<Col
									xs={6}
									style={{
										paddingBottom: "15px",
									}}
								>
									<Input.Search
										onSearch={this.handleSearchChange}
										onChange={this.handleSearchChange}
										value={service.search}
									/>
								</Col>
								<Col
									xs={18}
									style={{
										paddingBottom: "15px",
										paddingLeft: "15px",
									}}
								>
									<Button
										onClick={() => this.handleUploadRateFilesButtonClick()}
									>
										Upload Rate Files
									</Button>
									<Button
										style={{
											marginLeft: "15px",
										}}
										type="primary"
										onClick={() => this.handleReloadRateFilesButtonClick()}
									>
										Reload Rate Files
									</Button>
								</Col>
							</Row>
							<Row>
								<Col xs={24}>
									<Table
										rowKey="id"
										columns={columns}
										dataSource={service.rateFilesData}
										pagination={service.pagination}
										loading={service.loading}
										onChange={this.handleTableChange}
									/>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	handleReloadRateFilesButtonClick = () => {
		this.props.context.applicationService.reloadBusinessRules();
	};

	handleTableChange = (pagination, filters, sorter) => {
		const { rateFilesService } = this.props.context;

		rateFilesService.setPagination(pagination);
		rateFilesService.setSorter(sorter);

		rateFilesService.loadRateFilesData();
	};

	handleSearchChange = (...args) => {
		const value =
			args.length === 2
				? args[1].currentTarget.value
				: args[0].currentTarget.value;
		this.props.context.rateFilesService.setSearch(value);

		this.debouncedReloadItems();
	};

	handleValidateButtonClick = async (record) => {
		const { name } = record;

		if (name) {
			const { insuranceRateQuotingService } = this.props.context;
			insuranceRateQuotingService.setRateFileSelected(record);
			this.props.history.push(`/rates/${name}`);
		}
	};

	reloadRateFiles = async () => {
		await this.props.context.rateFilesService.loadRateFilesArchiveData();
	};

	debouncedReloadItems = debounce(this.reloadRateFiles, 250);

	handleUploadRateFilesButtonClick() {
		this.props.history.push("/rates");
	}

	handleDownloadButtonClick = async (record) => {
		const rateFileName = record.name;
		await this.props.context.rateFilesService.downloadRateFile(rateFileName);
	};
}

export default ActiveRates;
